class User {
  set fromJson(json: Map<string, any>) {
    this.id = json['id'];
    this.email = json['email'];
    this.role = json['role'];
    this.createdAt = json['createdAt'];
    this.updatedAt = json['updatedAt'];
  }

  get toJson() {
    return {
      id: this.id,
      email: this.email,
      role: this.role,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    };
  }

  public id: number | undefined;
  public email: string | undefined;
  public role: string | undefined;
  public createdAt: Date | undefined;
  public updatedAt: Date | undefined;
}

export default User;
